import React from "react";
import { Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      className="py-24 md:py-32 bg-green-50/30"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl shadow-green-900/10">
            <img
              src="https://images.pexels.com/photos/4506111/pexels-photo-4506111.jpeg"
              alt="Profesional examinando paciente"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl shadow-green-900/10 border border-slate-100 p-6 max-w-[220px] hidden md:block">
            <p className="font-display text-3xl font-bold text-green-700">+2,500</p>
            <p className="text-sm text-slate-600 mt-1">pacientes recuperados</p>
          </div>
        </div>

        <div>
          <span className="inline-block text-xs uppercase tracking-[0.25em] font-semibold text-green-700">
            {t.about.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            {t.about.title}
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">{t.about.p1}</p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">{t.about.p2}</p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {t.about.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
                <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-green-600 text-white">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                {b}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
